import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class DefaultSourcingService {

  constructor(private http: HttpClient) { }

  /**
   * Save default sourcing override data
   * Matches exact payload structure for action code y45hps
   */
  saveDefaultSourcing(
    baseUrl: string,
    overrideEntity: any,
    jsonSettings: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=y45hps`;

    // Build params with proper fallbacks (order: filterParams → globalService → rowData → default)
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Core parameters with fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || jsonSettings?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || jsonSettings?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || jsonSettings?.jcd_key || '250';
    
    // Additional parameters from filterParams/globalService
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '';
    
    // Build checkLockedbj array with scenario_key
    const scenarioKey = parseInt(params.scenario) || parseInt(filterParams?.scenario) || parseInt(globalService?.scenario) || 74;
    const checkLockedbj = [{
      scenario_key: scenarioKey
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // JSON objects
    params.clob_data = JSON.stringify(overrideEntity);
    params.clob_settings = JSON.stringify(jsonSettings);
    
    // Additional required parameters
    params.sso_id = jsonSettings?.sso_id || globalService?.sso_id || filterParams?.sso_id || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = 'N';
    params.process_name = 'SAVE_HO_DEF_SRC';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      // Include all values except undefined and null (empty strings are included)
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
